<form class="flex flex-wrap gap-2 pb-6" [formGroup]="form">
  <div class="flex w-full flex-col flex-wrap justify-start gap-4 pb-6 md:flex-row md:justify-end">
    <div class="flex items-center justify-start gap-1 md:justify-end">
      <app-switch colorTrue="bg-theme-300" formControlName="submit"></app-switch>
      {{ 'eclass.tarefa.aluno-responde-eclass' | translate }}
      <span
        type="button"
        #Eclass
        (click)="onOpenHelpText(Eclass, TypeHelpActivityEnum.Eclass)"
        class="flex items-center gap-2 whitespace-nowrap"
        app-tooltip
        [tooltip]="'gestor-avaliacoes.clique-para-ver-detalhes' | translate"
      >
        <svg-icon class="h-4 w-4 text-black" app-tooltip src="assets/icons/icon-interrogation.svg"></svg-icon>
      </span>
    </div>
    <div class="flex items-center justify-start gap-1 md:justify-end">
      <app-switch colorTrue="bg-theme-300" formControlName="limit"></app-switch>
      {{ 'eclass.tarefa.envio-atrasado' | translate }}
      <span
        type="button"
        #Late
        (click)="onOpenHelpText(Late, TypeHelpActivityEnum.Late)"
        class="flex items-center gap-2 whitespace-nowrap"
        app-tooltip
        [tooltip]="'gestor-avaliacoes.clique-para-ver-detalhes' | translate"
      >
        <svg-icon class="h-4 w-4 text-black" app-tooltip src="assets/icons/icon-interrogation.svg"></svg-icon>
      </span>
    </div>
    <div class="flex items-center justify-start gap-1 md:justify-end">
      <app-switch colorTrue="bg-theme-300" formControlName="evaluative"></app-switch>
      {{ 'geral.avaliativo' | translate }}
      <span
        type="button"
        #Evaluative
        (click)="onOpenHelpText(Evaluative, TypeHelpActivityEnum.Evaluative)"
        class="flex items-center gap-2 whitespace-nowrap"
        app-tooltip
        [tooltip]="'gestor-avaliacoes.clique-para-ver-detalhes' | translate"
      >
        <svg-icon class="h-4 w-4 text-black" app-tooltip src="assets/icons/icon-interrogation.svg"></svg-icon>
      </span>
    </div>
  </div>

  <div class="flex w-full flex-col flex-wrap gap-4 md:flex-row">
    <app-form-field class="flex-1 md:min-w-[20rem]">
      <label app-label translate>geral.titulo</label>
      <input app-input [placeholder]="'geral.titulo' | translate" formControlName="title" />
    </app-form-field>

    <app-form-field class="w-full flex-initial md:w-56">
      <label app-label translate>geral.data-fim</label>
      <app-input-datepicker
        [minDate]="date$ | async"
        [clearable]="false"
        [weekend]="false"
        [showTime]="true"
        formControlName="date_end"
      />
    </app-form-field>
  </div>

  <app-form-field class="w-full">
    <label app-label translate>geral.descricao</label>
    <app-text-editor
      class="block"
      [url]="textEditorUrl"
      [toolbar]="toolbar"
      formControlName="description"
    ></app-text-editor>
  </app-form-field>

  <div class="mb-6 flex w-full flex-col gap-2 rounded-md border border-base-gray-100 px-6 py-4">
    <div class="flex w-full flex-wrap justify-between">
      <h1 class="text-lg" translate>geral.quem-fara</h1>
      <div class="flex items-center gap-2">
        <span translate>geral.toda-turma</span>
        <app-switch colorTrue="bg-theme-300" formControlName="specificStudents"></app-switch>
        <span translate>geral.alunos-especificos</span>
      </div>
    </div>
    @if (form.value.specificStudents) {
      <div>
        <app-list-specific-students
          [targets]="targets$ | async"
          (selectAll)="onSelectAllStudents($event)"
          formControlName="students"
        ></app-list-specific-students>
      </div>
    }
  </div>
  <app-attachment-dropzone
    class="w-full mt-4 block"
    [maxSizeMB]="config.maxFilesize"
    [accept]="config.acceptedFiles"
    [multiple]="config.maxFiles > 1"
    [maxFiles]="config.maxFiles"
    folder="activities"
    [downloadable]="true"
    [previewable]="true"
    [initialAttachments]="existingAttachments"
    (uploadComplete)="onUploaded($event)"
    (filesChanged)="onFilesChanged($event)"
    (removeExisting)="onFileRemoved($event)"
  ></app-attachment-dropzone>
</form>
